import { Calendar } from 'owa-calendar-cache';
import { PickerOption, ParentOption, isParentOption } from 'owa-calendar-composite-picker';

/**
 * A Calendar option
 */
export interface CalendarOption extends PickerOption {
    calendar: Calendar;
}

/**
 * Checks if a PickerOption represents a Calendar
 * @param option The PickerOption
 */
export function isCalendarOption(option: PickerOption) {
    return (option as CalendarOption).calendar !== undefined;
}

/**
 * A Team option (From MS Teams)
 */
export interface TeamOption extends ParentOption {
    smtpAddress: string;
    profilePictureUrl: string;
}

/**
 * Checks if a Picker Option represents a Team
 * @param option The PickerOption
 */
export function isTeamOption(option: PickerOption) {
    return isParentOption(option) && (option as TeamOption).smtpAddress !== undefined;
}

/**
 * A Channel option (From MS Teams)
 */
export interface ChannelOption extends PickerOption {
    uid: string;
    rid: number;
    mid: number;
    channelType: number;
    private: boolean;
    parentTeamName: string;
    parentTeamSmtpAddress: string;
    isFavorite: boolean;
}

/**
 * Checks if a Picker option represents a Channel
 * @param option The PickerOption
 */
export function isChannelOption(option: PickerOption) {
    return (option as ChannelOption).uid !== undefined;
}
